<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-toolbar-title class="primary--text">{{ section }}</v-toolbar-title>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-data-table
        :key="currentRestaurant._id"
        v-if="currentRestaurant && currentRestaurant.wansoftId"
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="salesList.models"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
        </template>
        <template v-slot:item.order="{ item }">
          <div class="py-2">
            <a href="" @click.prevent="openSaleDetail(item)">
              {{ item.order }}
            </a>
          </div>
        </template>
        <template v-slot:item.dishes="{ item }">
          <div>
            {{ item.details.length }} {{ item.details.length === 1 ? 'Platillo' : 'Platillos' }}
          </div>
        </template>
        <template v-slot:item.total="{ item }">
          <div>
            <strong>{{ item.total | toFixNumber(2) | prefix('$') }} MXN</strong>
          </div>
        </template>
        <template v-slot:item.orderDate="{ item }">
          {{ item.updatedAt | toDate }}
        </template>
      </v-data-table>

      <div
        v-else
        class="d-flex justify-center mt-6">
        <v-row
          align="center"
          justify="center">
          <v-icon
            size="150"
            color="primary">
            mdi-cash-register
          </v-icon>
          <v-col cols="4">
            <div class="grey--text">
              <div
                class="title mb-3 font-weight-bold">
                Aún no tienes configurado tu punto de venta.
              </div>
              <div class="subtitle-2">
                <div class="mb-3">
                  Agrega el ID que tiene tu restaurant en tu punto de venta Wantsoft para poder extraer datos de tus ventas.
                </div>
                <div>
                  <router-link class="primary--text" :to="{ name: 'RestaurantSettings' }">Ir a configuracion</router-link>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-flex>

    <SaleDetail ref="saleDetail" />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import Sale from '@/models/Sale'
import SalesList from '@/models/collections/SalesList'
import SaleDetail from '@/components/sidePanels/SaleDetail.vue'

export default {
  name: 'Sales',
  components: {
    SaleDetail
  },
  data () {
    let salesList = new SalesList()
    let sale = new Sale({}, salesList)

    return {
      statuses: [{
        id: 'cooking',
        name: 'En preparación'
      }, {
        id: 'delivering',
        name: 'Enviada'
      }, {
        id: 'delivered',
        name: 'Entregada'
      }, {
        id: 'pending-payment',
        name: 'Pendiente de pago'
      }, {
        id: 'pending',
        name: 'Pendiente de revisión'
      }, {
        id: 'authorized',
        name: 'Autorizado'
      }, {
        id: 'in_process',
        name: 'En proceso de revisión'
      }, {
        id: 'in_mediation',
        name: 'En proceso de revisión'
      }, {
        id: 'approved',
        name: 'Pagada'
      }, {
        id: 'refunded',
        name: 'Devuelto'
      }, {
        id: 'charged_back',
        name: 'Cargo de nuevo'
      }, {
        id: 'in-review',
        name: 'En revisión del proveedor de pagos'
      }, {
        id: 'rejected',
        name: 'Rechazada por el proveedor de pagos'
      }, {
        id: 'cancelled',
        name: 'Cancelada'
      }],
      saleModel: sale,
      salesList,
      overlay: false,
      section: this.$i18n.t('Ventas del restaurant'),
      table: {
        title: this.$i18n.t('sales.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('sales.headers.order'), value: 'order' },
          { text: this.$i18n.t('No. de movimiento'), value: 'movement' },
          { text: this.$i18n.t('Tipo de orden'), value: 'orderType' },
          { text: this.$i18n.t('Cantidad'), value: 'dishes' },
          { text: this.$i18n.t('sales.headers.total'), value: 'total', sortable: false },
          { text: this.$i18n.t('Fecha de venta'), value: 'orderDate', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 50,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: ['updatedAt'],
          sortDesc: [true]
        }
      }
    }
  },
  computed: {
    currentRestaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  methods: {
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      this.table.options = data
      if (this.$store.state.area) {
        await this.load({
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1)),
          sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`,
          restaurant: this.currentRestaurant._id
        })
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`,
        restaurant: this.currentRestaurant._id
      }
      this.table.loading = true
      try {
        const { response } = await this.saleModel.fetch({ params })
        this.salesList.replace([response.data.data])
        this.table.total = response.data.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    openSaleDetail (item) {
      this.$refs.saleDetail.open(item)
    }
  }
}
</script>
